import { uiSize } from '@utils'

interface Props {
  color?: string
  size?: number | string
}

function UsersIcon({ color = 'currentColor', size = 18 }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <circle cx='9' cy='8' r='3.5' />
      <path d='M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6' />
      <path d='M15.5 4.7a3.5 3.5 0 0 1 0 6.6' />
      <path d='M18 14.4c2.2.7 3.5 2.6 3.5 5.6' />
    </svg>
  )
}

export default UsersIcon
